export const AsyncLoadChartData =
  ({ RestService, pResponseGeneric }) =>
  async () => {
    const chartData = await RestService.get('/api/admin/landing?view=all')

    return pResponseGeneric(chartData)
  }
